import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6f7d543e")
const _hoisted_1 = { id: "materials-sizes-btn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "material-option-desc" }, "Materials", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Choose a material ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", _hoisted_1, [
      _hoisted_2,
      (_ctx.currentMaterial)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "materials-info",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showLabelMaterials && _ctx.showLabelMaterials(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.currentMaterial.title) + " ", 1),
            _hoisted_3
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "materials-info",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showLabelMaterials && _ctx.showLabelMaterials(...args)))
          }, _hoisted_6))
    ])
  ]))
}